<template>
    <div class="l-row">
        <div class="l-row__column">
            <div class="o-dashboardInvoices a-mobile">
                <div class="l-row l-row--center">
                    <div class="l-row__column l-row__column--11">
                        <div class="o-dashboardInvoices__header">
                            <div
                                class="o-dashboardInvoices__column o-dashboardInvoices__column--top"
                            >
                                <p class="a-price a-price--left">
                                    Wszystkie płatności:
                                    <span class="a-price a-price--left a-price__price">
                                        {{ summary.sum_gross.toPLN() }}
                                    </span>
                                </p>
                            </div>
                            <div
                                class="o-dashboardInvoices__column o-dashboardInvoices__column--left"
                            >
                                <a-control
                                    label="Numer faktury lub adres"
                                    v-model="term"
                                    id="term"
                                />
                            </div>
                            <div
                                class="o-dashboardInvoices__column o-dashboardInvoices__column--right"
                            >
                                <div class="o-dashboardInvoices__column-item">
                                    <p class="a-label a-label--big">Wyświetlanie</p>
                                    <div>
                                        <button
                                            class="a-button o-dashboardInvoices__toggle"
                                            :class="{'o-dashboardInvoices__toggle--active': mode === 'issue'}"
                                            @click="mode = 'issue'"
                                        >
                                            DATA FAKTURY
                                        </button>
                                        <button
                                            class="a-button o-dashboardInvoices__toggle"
                                            :class="{'o-dashboardInvoices__toggle--active': mode === 'invoice'}"
                                            @click="mode = 'invoice'"
                                        >
                                            DATA PŁATNOŚCI
                                        </button>
                                    </div>
                                </div>
                                <div class="o-dashboardInvoices__column-item">
                                    <p class="a-label a-label--big">Zakres dat</p>
                                    <div class="o-dashboardInvoices__datepickerWrapper">
                                        <date-range-picker
                                            ref="picker"
                                            :show-dropdowns="true"
                                            :auto-apply="true"
                                            :ranges="false"
                                            :locale-data="localeData"
                                            v-model="dateRange"
                                            :append-to-body="false"
                                            :single-date-picker="false"
                                            control-container-class="a-control__input o-dashboardInvoices__datepicker"
                                            :linked-calendars="false"
                                        >
                                            <template
                                                v-if="dateRange"
                                                v-slot:input="picker"
                                            >
                                                {{ formatDate(picker.startDate) }} - {{ formatDate(picker.endDate) }}
                                            </template>
                                        </date-range-picker>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="invoicesStatus === 'pending'">
                        <a-icon icon="Spinner" />
                </div>
                <div
                    v-else-if="invoices && invoices.length > 0"
                    class="l-row l-row--center"
                >
                    <div class="l-row__column l-row__column--11">
                        <p
                            class="a-price a-price--left a-text--bold a-price--big"
                            id="invoiceList"
                        >
                            Lista faktur
                        </p>
                        <div class="o-dashboardInvoices__table">
                            <div class="o-dashboardInvoices__row">
                                <div class="o-dashboardInvoices__item">
                                    <p class="a-text o-dashboardInvoices__content">
                                        DATA WYSTAWIENIA
                                    </p>
                                </div>
                                <div class="o-dashboardInvoices__item">
                                    <p class="a-text o-dashboardInvoices__content">
                                        NR DOKUMENTU
                                    </p>
                                </div>
                                <div class="o-dashboardInvoices__item">
                                    <p class="a-text o-dashboardInvoices__content">
                                        DOKUMENT
                                    </p>
                                </div>
                                <div class="o-dashboardInvoices__item">
                                    <p class="a-text o-dashboardInvoices__content">
                                        TERMIN PŁATNOŚCI
                                    </p>
                                </div>
                                <div class="o-dashboardInvoices__item">
                                    <p class="a-text o-dashboardInvoices__content">
                                        KWOTA BRUTTO
                                    </p>
                                </div>
                                <div class="o-dashboardInvoices__item">
                                    <p class="a-text o-dashboardInvoices__content">
                                        DO ZAPŁATY
                                    </p>
                                </div>
                                <div class="o-dashboardInvoices__item">
                                    <p class="a-text o-dashboardInvoices__content">
                                        STATUS
                                    </p>
                                </div>
                            </div>
                            <div
                                v-for="(invoice, invoiceIdx) in invoices"
                                v-bind:key="`invoice${invoiceIdx}`"
                                class="o-dashboardInvoices__row"
                            >
                                <div class="o-dashboardInvoices__item">
                                    <p
                                        class="a-text o-dashboardInvoices__content"
                                        data-name="data wystawienia"
                                    >
                                        {{ invoice.issue_date }}
                                    </p>
                                </div>
                                <div class="o-dashboardInvoices__item">
                                    <p
                                        class="a-text o-dashboardInvoices__content"
                                        data-name="nr dokumentu"
                                    >
                                        {{ invoice.invoice_no }}
                                    </p>
                                </div>
                                <div class="o-dashboardInvoices__item o-dashboardInvoices__item--file">
                                    <a
                                        v-if="pdfStatus !== `pending${invoice.invoice_no.replace(/\//g, '-')}`"
                                        href="#"
                                        @click.prevent.stop="downloadInvoice({
                                            link: invoice.pdf,
                                            name: invoice.invoice_no
                                        })"
                                        download="docs"
                                        class="a-text a-link o-dashboardInvoices__content"
                                        data-name="dokument"
                                    >
                                        <a-icon class="a-icon" icon="Document" />
                                    </a>
                                    <div v-else>
                                        <a-icon icon="SpinnerSmall" />
                                    </div>
                                </div>
                                <div class="o-dashboardInvoices__item">
                                    <p
                                        class="a-text o-dashboardInvoices__content"
                                        data-name="termin płatności"
                                    >
                                        {{ invoice.payment_date }}
                                    </p>
                                </div>
                                <div class="o-dashboardInvoices__item">
                                    <p
                                        class="a-text o-dashboardInvoices__content"
                                        data-name="kwota brutto"
                                    >
                                        {{ invoice.status.symbol === 'paid' ? invoice.value_gross.toPLN() : '-' }}
                                    </p>
                                </div>
                                <div class="o-dashboardInvoices__item">
                                    <p
                                        class="a-text o-dashboardInvoices__content"
                                        data-name="do zapłaty"
                                    >
                                        {{ invoice.status.symbol === 'paid' ? '-' : invoice.value_gross.toPLN() }}
                                    </p>
                                </div>
                                <div class="o-dashboardInvoices__item">
                                    <p
                                        class="a-text o-dashboardInvoices__content"
                                        data-name="status"
                                    >
                                        {{ invoice.status.name }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div
                            class="o-dashboardInvoices__pagination"
                            v-if="invoicesPaginationTotal > 1"
                        >
                            <a-button
                                class="o-dashboardInvoices__paginationItem"
                                :selected="page === invoicesPaginationCurrent"
                                @click="setPage(page)"
                                v-for="page in invoicesPaginationTotal"
                                v-bind:key="page"
                            >
                                {{ page }}
                            </a-button>
                        </div>
                    </div>
                </div>
                <div
                    v-else
                    class="l-row l-row--center"
                >
                    <div class="l-row__column l-row__column--11">
                        <p class="a-price a-price--left a-text--bold a-price--big">
                            Brak faktur
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
    components: {
        DateRangePicker
    },
    data() {
        return {
            // startDate: '2020-11-01',
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().endOf('year').format('YYYY-MM-DD'),
            mode: 'issue',
            term: ''
        }
    },
    computed: {
        dateRange: {
            get() {
                return {
                    startDate: this.startDate,
                    endDate: this.endDate
                }
            },
            set(dateRange) {
                this.startDate = moment(dateRange.startDate).format('YYYY-MM-DD')
                this.endDate = moment(dateRange.endDate).format('YYYY-MM-DD')
            }
        },
        localeData() {
            return {
                firstDay: 1,
                format: 'DD-MM-YYYY',
                daysOfWeek: ['Nd', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
                monthNames: [
                    'Styczeń',
                    'Luty',
                    'Marzec',
                    'Kwiecień',
                    'Maj',
                    'Czerwiec',
                    'Lipiec',
                    'Sierpień',
                    'Wrzesień',
                    'Październik',
                    'Listopad',
                    'Grudzień'
                ]
            }
        },
        invoices() {
            return this.$store.getters['invoices/list']
        },
        summary() {
            return this.$store.getters['invoices/summary']
        },
        invoicesStatus() {
            return this.$store.getters['invoices/listStatus']
        },
        invoicesPaginationTotal() {
            return this.$store.getters['invoices/paginationTotal']
        },
        invoicesPaginationCurrent() {
            return this.$store.getters['invoices/paginationCurrent']
        },
        pdfStatus() {
            return this.$store.getters['invoices/pdfStatus']
        }
    },
    watch: {
        dateRange: {
            deep: true,
            handler() {
                this.fetchInvoices()
            }
        },
        mode() {
            this.fetchInvoices()
        },
        term() {
            this.fetchInvoices()
        }
    },
    methods: {
        moment(date) {
            return moment(date)
        },
        formatDate(date) {
            return moment(date).format('DD.MM.YYYY')
        },
        dateFormat(classes, date) {
            classes.disabled = moment(date).isBefore(this.minimumDate)
            return classes
        },
        fetchInvoices() {
            return this.$store.dispatch('invoices/fetchList', {
                dateMode: this.mode,
                startDate: this.startDate,
                endDate: this.endDate,
                term: this.term
            })
        },
        downloadInvoice(payload) {
            this.$store.dispatch('invoices/fetchPdf', {
                name: payload.name.replace(/\//g, '-'),
                link: payload.link
            })
        },
        setPage(page) {
            this.$store.dispatch('invoices/setListPage', page)
            this.fetchInvoices().then(() => {
                // scroll to invoices
                this.$scrollTo('#invoiceList', 500, {
                    offset: -110
                })
            })
        }
    },
    created() {
        this.fetchInvoices()
    }
}
</script>

<style>
</style>
